import ProductCard, { UnsfItem } from "./ProductCard"

interface NewInProps {
  title: string
  items: UnsfItem[]
  i18n: {
    soldout: string
    last_pieces: string
    no_image: string
    pre_sale: string
  }
}

export default function NewIn({ title, items, i18n }: NewInProps) {
  if (items.length === 0) return null

  return (
    <section className="py-16 md:py-24 bg-light">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-start gap-8 lg:gap-16">
          <div className="lg:w-1/4">
            <h2 className="text-3xl md:text-4xl font-bold text-contrast">
              {title}
            </h2>
          </div>
          <div className="lg:w-3/4">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {items.map((item) => (
                <ProductCard key={item.id} item={item} i18n={i18n} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
